import api from '../api/api'

const SET_STAFF_PERSONS = 'SET_STAFF_PERSONS'
const ADD_STAFF_PERSON = 'ADD_STAFF_PERSON'
const UPDATE_STAFF_PERSON = 'UPDATE_STAFF_PERSON'
const DELETE_STAFF_PERSON = 'DELETE_STAFF_PERSON'

const initialState = {
  staffPersons: [],
}

const updateStaffPersonsState = (state, { staffPerson }) =>
  state.staffPersons.map((person) => {
    if (person.id === staffPerson.id) {
      return staffPerson
    }
    return person
  })

const maintenanceStaffReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STAFF_PERSONS:
      return {
        ...state,
        staffPersons: action.staffPersons,
      }
    case UPDATE_STAFF_PERSON:
      return {
        ...state,
        staffPersons: updateStaffPersonsState(state, action),
      }
    case ADD_STAFF_PERSON:
      return {
        ...state,
        staffPersons: [...state.staffPersons, action.staffPerson],
      }
    case DELETE_STAFF_PERSON:
      return {
        ...state,
        staffPersons: [...state.staffPersons].filter(({ id }) => id !== action.staffPersonId),
      }
    default:
      return state
  }
}

const setStaffPersonsAction = (staffPersons) => {
  return {
    type: SET_STAFF_PERSONS,
    staffPersons,
  }
}
const updateStaffPersonAction = (staffPerson) => {
  return {
    type: UPDATE_STAFF_PERSON,
    staffPerson,
  }
}
const addStaffPersonAction = (staffPerson) => {
  return {
    type: ADD_STAFF_PERSON,
    staffPerson,
  }
}
const deleteStaffPersonAction = (staffPersonId) => {
  return {
    type: DELETE_STAFF_PERSON,
    staffPersonId,
  }
}

export const fetchStaff = (buildingId) => {
  return (dispatch) =>
    api
      .getMaintenanceStaffByBuildingId(buildingId)
      .then((res) => {
        dispatch(setStaffPersonsAction(res))
        return Promise.resolve()
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const deleteStaffPerson = (buildingId, staffPersonId) => {
  return (dispatch) => {
    return api
      .deleteStaffPerson(buildingId, staffPersonId)
      .then(() => {
        dispatch(deleteStaffPersonAction(staffPersonId))
        return Promise.resolve()
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const createStaffPerson = (buildingId, data) => {
  return (dispatch) => {
    return api
      .createStaffPerson(buildingId, { buildingIds: [buildingId], ...data })
      .then((res) => {
        dispatch(addStaffPersonAction(res))
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }
}

export const updateStaffPerson = (buildingId, staffPersonId, payload) => {
  return (dispatch) =>
    api
      .updateStaffPerson(buildingId, staffPersonId, { buildingIds: [buildingId], ...payload })
      .then((updatedStaffPerson) => {
        dispatch(updateStaffPersonAction(updatedStaffPerson))
        return Promise.resolve(updatedStaffPerson)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const selectStaffPersons = (state) => state.staff.staffPersons

export const selectStaffOptions = (state) =>
  state.staff.staffPersons
    .filter((staffPerson) => staffPerson.user)
    .map((staffPerson) => ({
      value: staffPerson.user.id,
      label: `${staffPerson.user.firstName} ${staffPerson.user.lastName}`,
    }))

export default maintenanceStaffReducer
